import { SortItem } from '../ss-api/responses/member.dashboard.license.response';
import { VersionHardwareRequirementItemArray } from './version.hardware.requirement.item';

export class VersionItemArray extends Array<VersionItem> {
    public LastSort = new SortItem;

    constructor(...items: VersionItem[]) {
        super(...items);
        Object.setPrototypeOf(this, VersionItemArray.prototype);
    }

}

export class VersionItem {
    ID: number;
    Version: string;
    VersionInt: number;
    Name: string;
    Description: string;
    IsMinorUpdate: boolean;
    Enabled: boolean;
    Postponable: boolean;
    FileLocation: string;
    MinimumLiveHubVersion: number;
    MinimumScoreThreshold: number;
    RecommendedScoreThreshold: number;
    PostponeGroupID?: number;
    PostponeGroupName: string;
    VersionHardwareRequirementItems: VersionHardwareRequirementItemArray;
}
